import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "restaurant/menu-management/sub-categories";
const options = { role: ROLE.RESTAURANT };

export const getSubCategories = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const addSubCategory = async (values) => {
  return await axiosInstance(options).post(`${path}/add`, values);
};

export const editSubCategory = async (values) => {
  return await axiosInstance(options).put(`${path}/edit`, values);
};

export const deleteSubCategory = async (values) => {
  return await axiosInstance(options).delete(`${path}/delete?o_id=${values.o_id}`);
};

export const subCategoryDetail = async (values) => {
  return await axiosInstance(options).get(`${path}/details?o_id=${values.o_id}`);
};

export const sortSubCategories = async (values) => {
  return await axiosInstance(options).patch(`${path}/sort`, values);
};

export const subCategoryOptions = async (category_id) => {
  return await axiosInstance(options).get(`${path}/options?category_id=${category_id || ""}`);
};
